import { ALERT_DATE_RANGES_DIFFERENCE } from '@shared/widgets/constants/alert.constant';

export function alertDateBoundFormat(date: Date, flexDates: boolean, addDays: boolean = false): string {
  if (date) {
    const newDate = new Date(date);
    if (flexDates) {
      if (addDays) newDate.setDate(newDate.getDate() + ALERT_DATE_RANGES_DIFFERENCE);
      else newDate.setDate(newDate.getDate() - ALERT_DATE_RANGES_DIFFERENCE);
    }
    const day = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getUTCFullYear();
    const mo = month < 10 ? `0${month}` : month;
    const da = day < 10 ? `0${day}` : day;
    return `${year}-${mo}-${da}`;
  } else return null;
}

export function invertAlertDateBoundFormat(dateString: string, flexDates: boolean, isArrival: boolean = false): string {
  const date = dateString ? dateString.replace(/-/g, '/') : null;
  if (date) {
    const newDate = new Date(date);
    if (flexDates) {
      if (isArrival) newDate.setDate(newDate.getDate() - ALERT_DATE_RANGES_DIFFERENCE);
      else newDate.setDate(newDate.getDate() + ALERT_DATE_RANGES_DIFFERENCE);
    }
    const day = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getUTCFullYear();
    const mo = month < 10 ? `0${month}` : month;
    const da = day < 10 ? `0${day}` : day;
    return `${year}-${mo}-${da}`;
  } else return null;
}
